import Cookies from 'universal-cookie'

const cookies = new Cookies()

// Headers that identify the signed-in staff member on legacy REST calls.
// Empty when nobody is signed in, so callers can always spread the result.
export const authHeaders = () => {
  const token = cookies.get('admin_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

const pad = (n) => String(n).padStart(2, '0')
const shortDate = (d) => `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${pad(d.getFullYear() % 100)}`

// Same patterns the server uses for the Content-Disposition file name. They are only a
// fallback: a cross-origin response hides Content-Disposition from the browser unless
// the server exposes it.
export const fallbackFileNames = {
  cashTransactions: () => `transaksi_${shortDate(new Date())}.xlsx`,
  cashAccounts: () => `akun_saku_${shortDate(new Date())}.xlsx`,
  menuOrders: () => `order_${shortDate(new Date())}.xlsx`,
  rooms: () => {
    const now = new Date()
    return `status_kamar_${shortDate(now)}_${pad(now.getHours())}${pad(now.getMinutes())}.xlsx`
  },
}

const fileNameFromDisposition = (header) => {
  if (!header) return null
  const encoded = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header)
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim())
    } catch (e) {
      // fall through to the plain form
    }
  }
  const plain = /filename\s*=\s*("([^"]*)"|[^;]+)/i.exec(header)
  if (!plain) return null
  return (plain[2] !== undefined ? plain[2] : plain[1]).trim() || null
}

// Downloads `url` with the signed-in token and saves the response under the file name
// the server sends. Replaces `window.location.href = url`, which cannot carry a header.
export const downloadWithAuth = async (url, fallbackFileName) => {
  try {
    const response = await fetch(url, { method: 'GET', headers: authHeaders() })
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`)
    }
    const blob = await response.blob()
    const fileName = fileNameFromDisposition(response.headers.get('Content-Disposition')) || fallbackFileName
    const objectUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000)
  } catch (error) {
    console.log(error)
    alert('Gagal mengunduh berkas. Silakan coba lagi.')
  }
}
